import usePermissions from '../hooks/usePermissions';

/**
 * Renderizado condicional por permisos. Envuelve cualquier elemento (botón,
 * MenuItem, columna, sección...) que deba ocultarse si el usuario no tiene
 * el permiso requerido.
 *
 * Modos de uso:
 *
 *  1) Permiso simple (modulo + accion):
 *       <Can modulo="prestamos" accion="crear">
 *         <Button>Nuevo préstamo</Button>
 *       </Can>
 *
 *  2) OR de varios permisos (cualquiera basta):
 *       <Can modulos={[['pagos','crear'], ['pagos','editar']]}>
 *         <Button>Gestionar pagos</Button>
 *       </Can>
 *
 *  3) AND de varios permisos (todos requeridos):
 *       <Can todas={[['prestamos','ver'], ['pagos','ver']]}>
 *         <Reporte />
 *       </Can>
 *
 *  4) Combinado con módulo contratado por la compañía:
 *       <Can modulo_contratado="inversionistas" modulo="inversionistas" accion="ver">
 *         <Tab label="Inversionistas" />
 *       </Can>
 *
 *  5) Con fallback (ej. mostrar deshabilitado en lugar de ocultar):
 *       <Can
 *         modulo="prestamos"
 *         accion="cancelar"
 *         fallback={<MenuItem disabled>Cancelar</MenuItem>}
 *       >
 *         <MenuItem onClick={cancelar}>Cancelar</MenuItem>
 *       </Can>
 */
export default function Can({
  modulo,
  accion,
  modulos,
  todas,
  modulo_contratado,
  fallback = null,
  children,
}) {
  const { hasPermission, hasAny, hasAll, hasModule } = usePermissions();

  if (modulo_contratado && !hasModule(modulo_contratado)) {
    return fallback;
  }

  let allowed;
  if (modulos) allowed = hasAny(modulos);
  else if (todas) allowed = hasAll(todas);
  else allowed = hasPermission(modulo, accion);

  return allowed ? children : fallback;
}
